function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#38b1df;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Graph Icons");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_534",
  "data-name": "Group 534"
}, React.createElement("g", {
  id: "Ellipse_54",
  "data-name": "Ellipse 54"
}, React.createElement("path", {
  className: "cls-1",
  d: "M13.41,26a12.5,12.5,0,1,1,12.5-12.5A12.51,12.51,0,0,1,13.41,26Zm0-23a10.5,10.5,0,1,0,10.5,10.5A10.51,10.51,0,0,0,13.41,3Z"
})), React.createElement("g", {
  id: "Path_113",
  "data-name": "Path 113"
}, React.createElement("path", {
  className: "cls-1",
  d: "M17.23,19.64a1,1,0,0,1-.71-.3L12.16,15a1,1,0,0,1-.3-.7V8.1a1,1,0,0,1,2,0v5.75l4.08,4.08a1,1,0,0,1-.71,1.71Z"
})));

var SvgTransactionTimes = function SvgTransactionTimes(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 26.55 26.81",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTransactionTimes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transaction-times.ed4e64d2.svg";
export { ForwardRef as ReactComponent };